import {
  DASHBOARD,
  LOCKSCREEN,
  MY_PROFILE,
  UPDATE_PASSWORD,
} from "@constants/routes";
import LockScreen from "@pages/Account/LockScreen";
import Profile from "@pages/Account/Profile";
import UpdatePassword from "@pages/Account/UpdatePassword";
import Dashboard from "@pages/Dashboard";
import { Route, Switch } from "react-router-dom";

const Account = () => (
  <Switch>
    <Route exact path={UPDATE_PASSWORD} component={UpdatePassword} />
    <Route exact path={MY_PROFILE} component={Profile} />
    <Route exact path={DASHBOARD} component={Dashboard} />
    <Route exact path={LOCKSCREEN} component={LockScreen} />
  </Switch>
);

export default Account;
